
export const navbar = {
  'backoffice.navbar.notifications': 'Notifiche',
  'backoffice.navbar.language': 'Lingua',
  'backoffice.navbar.signIn': 'Accedi'
};
